import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function AlarmClockIcon(props) {
  return (
    <SvgIcon viewBox="0 0 62 68" title="Alarm Clock" {...props}>
      <g clipPath="url(#clip0_1774_3944)">
        <path d="M54.6544 38.32C54.6544 25 43.8238 14.2 30.4661 14.2C17.1085 14.2 6.28125 24.9967 6.28125 38.32C6.28125 46.4033 10.2692 53.56 16.3898 57.9367L11.974 66.5467L13.5183 67.3333L17.8439 58.8967C21.5176 61.1433 25.8431 62.44 30.4695 62.44C35.7811 62.44 40.695 60.7333 44.6862 57.8367L49.5567 67.3367L51.101 66.55L46.0768 56.75C51.325 52.3267 54.6577 45.7133 54.6577 38.3233L54.6544 38.32Z" />
        <path d="M8.69461 3.14334C1.4007 7.12334 -1.27351 16.25 2.71775 23.5267L29.1222 9.10667C25.131 1.83 15.9852 -0.839998 8.69461 3.14334Z" />
        <path d="M51.7564 1.78C44.058 -1.35 35.2765 2.34 32.1377 10.02L60.013 21.3533C63.1485 13.6733 59.4514 4.91 51.753 1.78H51.7564Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.5437 21.356L28.6104 39.2036L28.687 39.2162L34.4602 55.0779L35.9637 54.5307L30.2795 38.9135L33.1225 21.6155L31.5437 21.356Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1774_3944">
          <rect
            width="60.2667"
            height="66.6667"
            fill="white"
            transform="translate(0.866211 0.666668)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default AlarmClockIcon;
